/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsOneOffPaymentNotice204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsOneOffPaymentNotice505Schema = z.any();

export const optionsOneOffPaymentNoticeMutationResponseSchema = z.lazy(() => optionsOneOffPaymentNotice204Schema);
